import React, { useEffect, useState } from 'react'
import { useStyles } from './style'
import { CaseNameType } from '@/entities/cases'

export const MemoizedVideo = React.memo<{
  videoRef: React.RefObject<HTMLVideoElement>
  caseName: CaseNameType
}>(({ videoRef, caseName }) => {
  const { classes } = useStyles()

  const commonVideoProps = {
    ref: videoRef,
    src: `/assets/video/${caseName}_roulette.webm`,
    autoPlay: true,
    muted: true,
    playsInline: true,
  }

  const [appeared, setAppeared] = useState<boolean>(false)

  useEffect(() => {
    setTimeout(() => {
      setAppeared(true)
    }, 322)
  }, [videoRef, caseName])

  return (
    <div className={classes.videoWrapper}>
      <video data-appeared={appeared} {...commonVideoProps} controls={false} />
    </div>
  )
})
